import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { Chip, Stack } from '@mui/material'
import { CellProps } from 'react-table'

import CalendarIcon from '@/components/ui/icons/Calendar'
import { OfflineConsultation } from '@/core/offline'

export function StartDateCell({ value }: CellProps<OfflineConsultation, OfflineConsultation['startDate']>) {
  const { t } = useTranslation()

  return (
    <Stack alignItems="center" justifyContent="start" direction="row" spacing={1}>
      <CalendarIcon fontSize="small" />
      <Chip
        color="secondary"
        label={
          <span>
            {dayjs(value).isSame(dayjs(), 'day') ? t(`dayjs:calendar:today`) : dayjs(value).format('DD/MM/YYYY')} - <b>{dayjs(value).format('HH[h]mm')}</b>
          </span>
        }
        variant="filled"
      />
    </Stack>
  )
}
